import buttons from './buttons';
import textMessages from './textMessages';
import merge from 'lodash/merge';

export default merge(buttons, textMessages);


// WEBPACK FOOTER //
// ./user/localization/ru/index.ts